export const audioTypes = [
    { key: "Close Talk", value: 'closetalk' },
    { key: "Telephony", value: 'telephony' },
];

export const audioTracks = [
    { key: "Single", value: 'single' },
    { key: "Multi", value: 'multi' },
];

